import React, { useMemo } from "react";
import { Context } from "@hotwired/stimulus";
import { useForm } from "react-hook-form";
import { valibotResolver } from "@hookform/resolvers/valibot";
import { ReactWrapperController } from "@root/server/client/esweb/src/lib/stimulus/ReactWrapperController.ts";
import { Form } from "@root/server/client/esweb/components/ui/form.tsx";
import { FormInput } from "@root/server/client/esweb/components/ui/rhf/FormInput.tsx";
import { FormServerErrors } from "@root/server/client/esweb/src/pages/web/shared/form-server-errors.tsx";
import { useFormSubmission } from "@root/server/client/esweb/src/lib/hooks/useFormSubmission.ts";
import {
    ContinueSubmitButton,
    SendSubmitButton
} from "@root/server/client/esweb/src/pages/web/shared/continue-submit-button.tsx";
import {
    HookFilterTestFormSchema,
    HookFilterTestFormValues
} from "./hook_filter_form.shared.ts";
import {FormTextarea} from "@root/server/client/esweb/components/ui/rhf/FormTextarea.tsx";
import {FormSelect} from "@root/server/client/esweb/components/ui/rhf/FormSelect.tsx";

export const name = 'monitor-test-form';

export default class extends ReactWrapperController {
    constructor(context: Context) {
        super(context, (props) => <MonitorTestForm {...props} />);
    }
}

function MonitorTestForm({ submitUrl, initialData }: { submitUrl: string, initialData: HookFilterTestFormValues }) {
    const defaultValues = useMemo<HookFilterTestFormValues>(() => ({
        content: initialData?.content ?? '',
        contentType: initialData?.contentType ?? 'text/plain',
    }), [initialData]);

    const form = useForm({
        resolver: valibotResolver(HookFilterTestFormSchema),
        defaultValues,
        mode: "onTouched",
    });

    const { control, handleSubmit} = form;
    const { execute, isSubmitting, canSubmit, serverErrors } = useFormSubmission({ submitUrl });

    return (
        <Form {...form}>
            <form onSubmit={handleSubmit(execute)} className="space-y-4">
                <div className="grid grid-cols-1 gap-4">
                    <FormSelect 
                        control={control} 
                        name="contentType" 
                        label="Content Type" 
                        options={[
                            {label: 'Text (text/plain)', value: 'text/plain'},
                            {label: 'JSON (application/json)', value: 'application/json'}
                        ]} 
                    />
                    <FormTextarea control={control} name="content" label="Payload" placeholder="e.g. This is a test payload" />
                </div>

                <FormServerErrors errors={serverErrors} />
                <SendSubmitButton label={'Send test payload'} isSubmitting={isSubmitting} canSubmit={canSubmit} />
            </form>
        </Form>
    );
}